import { orderBy } from 'lodash';

export const SEARCH_SET_ORDER = 'SEARCH_SET_ORDER';

export const SEARCH_SET_ARTICLES = 'SEARCH_SET_ARTICLES';
export const SEARCH_TOGGLE_ARTICLES_VIEW = 'SEARCH_TOGGLE_ARTICLES_VIEW';
export const SEARCH_SET_DISPLAYED_ARTICLES = 'SEARCH_SET_DISPLAYED_ARTICLES';

const ARTICLE_COUNT_ON_PAGE = 3;


export const initArticles = articles => (dispatch) => {
    dispatch(setArticles(articles));
    dispatch(setDisplayedArticles());
}

const setArticles = (articles) => ({
    type: SEARCH_SET_ARTICLES,
    payload: { articles }
})
const sliceArticles = (isArticlesShortView, articles) => isArticlesShortView ? articles.slice(0, ARTICLE_COUNT_ON_PAGE) : articles
export const toggleArticlesView = () => (dispatch, getState) => {
    const isArticlesShortView = !getState().search.isArticlesShortView;
    dispatch({
        type: SEARCH_TOGGLE_ARTICLES_VIEW,
        payload: { isArticlesShortView }
    });
    dispatch(setDisplayedArticles());
}

const setDisplayedArticles = () => async (dispatch, getState) => {
    const { articles, order, isArticlesShortView } = getState().search;
    const orderedArticles = await orderItems(articles, order);
    const displayedArticles = sliceArticles(isArticlesShortView, orderedArticles);
    dispatch({
        type: SEARCH_SET_DISPLAYED_ARTICLES,
        payload: { displayedArticles }
    })
}

const orderItems = async (items, order) => {
    switch (order) {
        case 'NAME_ASC':
            return await orderBy(items, ['title'], ['asc']);
        case 'NAME_DESC':
            return await orderBy(items, ['title'], ['desc']);
        default:
            return await items
    }
}


export const setOrder = (order) => (dispatch) => {
    dispatch({
        type: SEARCH_SET_ORDER,
        payload: { order }
    });
    dispatch(setDisplayedArticles());
}